/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.production = process.env.PRODUCTION || "true",
config.sitecoreApiHost = process.env.SITECORE_API_HOST || "https://www.piraeusaedak.gr",
config.sitecoreApiKey = process.env.SITECORE_API_KEY || "{1C48EE36-6854-4CB4-A8B4-9A96324D21B7}",
config.jssAppName = process.env.JSS_APP_NAME || "piraeusaedak",
config.sitecoreLayoutServiceConfig = process.env.SITECORE_LAYOUT_SERVICE_CONFIG || "sxa-jss",
config.defaultLanguage = process.env.DEFAULT_LANGUAGE || "en",
config.defaultServerRoute = process.env.DEFAULT_SERVER_ROUTE || "/",
config.layoutServiceConfigurationName = process.env.LAYOUT_SERVICE_CONFIGURATION_NAME || "sxa-jss",
config.urlOrigin = process.env.URL_ORIGIN || "https://www.piraeusaedak.gr",
config.assetsUrl = process.env.ASSETS_URL || "/dist/piraeusaedak/browser/assets/",
config.searchApiHost = process.env.SEARCH_API_HOST || "https://discover-euc1.sitecorecloud.io/discover/v2/",
config.searchPublishEventApiHost = process.env.SEARCH_PUBLISH_EVENT_API_HOST || "https://discover-euc1.sitecorecloud.io/event/11180407-233505176/v4/publish",
config.searchDomainId = process.env.SEARCH_DOMAIN_ID || "233505176",
config.searchApiKey = process.env.SEARCH_API_KEY || "01-62db6f03-421358e57497fe599436b847c05968e6cfefeff1",
config.searchApiSource = process.env.SEARCH_API_SOURCE || "1202389",
config.searchViewEventsEnabled = process.env.SEARCH_VIEW_EVENTS_ENABLED || "false",
config.recaptchaSiteKey = process.env.RECAPTCHA_SITE_KEY || "",
config.cookieDomain = process.env.COOKIE_DOMAIN || "0197c5f3-2e9a-72b2-8420-8f2bec3360d7-test",
config.notFound404 = process.env.NOT_FOUND404 || "404-page",
config.growthTrackerPath = process.env.GROWTH_TRACKER_PATH || "",
config.growthTrackingPath = process.env.GROWTH_TRACKING_PATH || "",
config.graphQLEndpointPath = process.env.GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/edge",
config.userWayEnabled = process.env.USER_WAY_ENABLED || "false",
config.graphQLEndpoint = process.env.GRAPH_QL_ENDPOINT || `${config.sitecoreApiHost}${config.graphQLEndpointPath}`;
module.exports.environment = config;